export default "__VITE_ASSET__DsPsWJnN__"